import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { auth0Config } from './auth/config'
import { setTokenProvider } from './lib/api'
import './styles/global.css'

import { Dashboard } from './pages/Dashboard'
import { Namespaces } from './pages/Namespaces'
import { NamespaceDetail } from './pages/NamespaceDetail'
import { ModuleDetail } from './pages/ModuleDetail'
import { Publish } from './pages/Publish'
import { Tokens } from './pages/Tokens'
import { Members } from './pages/Members'
import { NamespaceSettings } from './pages/NamespaceSettings'
import { Analytics, NamespaceAnalytics } from './pages/Analytics'

function AppRoutes() {
  const { isAuthenticated, isLoading, loginWithRedirect, getAccessTokenSilently } = useAuth0()

  // Wire the Auth0 token into the API client
  setTokenProvider(getAccessTokenSilently)

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#07090d', color: '#dde6f0' }}>
        Loading…
      </div>
    )
  }

  if (!isAuthenticated) {
    void loginWithRedirect()
    return null
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/namespaces" element={<Namespaces />} />
      <Route path="/namespaces/:slug" element={<NamespaceDetail />} />
      <Route path="/namespaces/:slug/modules/:name/:provider" element={<ModuleDetail />} />
      <Route path="/namespaces/:slug/publish" element={<Publish />} />
      <Route path="/namespaces/:slug/tokens" element={<Tokens />} />
      <Route path="/namespaces/:slug/members" element={<Members />} />
      <Route path="/namespaces/:slug/settings" element={<NamespaceSettings />} />
      <Route path="/namespaces/:slug/analytics" element={<NamespaceAnalytics />} />
      <Route path="/analytics" element={<Analytics />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <Auth0Provider {...auth0Config}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Auth0Provider>
  </StrictMode>,
)
